// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .img-container {
      display: flex;
      align-items: center;
      margin-top: 10px;
      cursor: pointer;
      color: #3D3DB8;
      width: 2px;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/shared/components/health-monitoring-actions-button-renderer.component.ts"],"names":[],"mappings":";IACI;MACE,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,UAAU;IACZ","sourcesContent":["\n    .img-container {\n      display: flex;\n      align-items: center;\n      margin-top: 10px;\n      cursor: pointer;\n      color: #3D3DB8;\n      width: 2px;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
